
export default {
  data: () => ({
    steps: [
      {
        title: "Audit de votre site actuel",
        text: `L'audit de votre site chez ALEO est essentiel. Nos conseillers analysent votre site pour trouver les <strong>améliorations nécessaires</strong>, incluant le design, l'expérience utilisateur, la navigation, le contenu et les aspects techniques. L’audit prend également en compte votre stratégie de référencement et vous aidera à mieux comprendre votre position sur Google.`,
        image: "refonte-step-1.png",
      },
      {
        title: "Définir les objectifs de votre refonte",
        text: `<p>Pendant votre point avec le conseiller commercial, nous vous aiderons à déterminer avec <strong>précision vos objectifs sur votre site internet</strong> : améliorer l'expérience utilisateur, accroître votre visibilité en ligne, renforcer votre image, mettre en avant différents services, présenter l’histoire de votre entreprise, etc.</p>
        <p class="mt-2">Pendant ce point, le conseiller ALEO prendra également en note tous les éléments que vous voudrez voir apparaître sur <strong>votre nouveau site internet</strong>, que cela soit des éléments graphiques (images, logos, couleurs) ou des éléments de texte. </p>
        `,
        image: "refonte-step-2.png",
      },
      {
        title: "Création de votre nouveau site",
        text: `<p>Les équipes ALEO s’occupent ensuite de la <strong>conception de votre site internet</strong> afin qu’il soit moderne et cohérent avec votre image de marque. Nous mettons au cœur de nos préoccupations l’expérience utilisateur à travers une navigation simple et intuitive.</p>
        `,
        image: "refonte-step-3.png",
      },
      {
        title: "Rédaction des contenus SEO",
        text: `<p>Nous créons des contenus qui non seulement intéressent vos visiteurs, mais qui amélioreront également votre classement sur Google, en intégrant des mots-clés pertinents aux bons endroits.</p>
        `,
        image: "refonte-step-4.png",
      },
      {
        title: "Redirections vers votre nouveau site",
        text: `<p>Nous mettons en place des <strong>redirections stratégiques</strong> pour assurer que les anciennes pages renvoient efficacement vers les nouvelles, évitant ainsi les erreurs 404 et la perte de trafic.</p>
        `,
        image: "refonte-step-5.png",
      },
    ],

    faq: [
      {
        question: "Définition : qu’est-ce qu'une refonte ?",
        answer: `<p>Une <strong>refonte de site internet</strong>, c’est recréer votre site internet en partant de 0 pour qu’il soit conforme aux tendances actuelles des sites internet. Au-delà d’une réfection au niveau du design, une refonte touche à l’architecture de votre site internet, à l’amélioration de l’UX (expérience utilisateur), à la mise à jour de votre contenu.</p>
            <p class="mt-4">L’objectif est de faire en sorte que votre site soit conforme aux attentes de vos clients potentiels en termes de webdesign (mobile friendly et facile à naviguer) et en termes de recherches sur Google. Effectuer une refonte de votre site internet est le point de départ idéal pour retravailler votre stratégie de référencement naturel (SEO), ce qui vous permettra de booster votre stratégie de marketing digital et d’attirer plus de clients sur Google.</p>
            `,
        isCollapsed: false,
      },
      {
        question: "Quelle est la durée d’une refonte de site internet ?",
        answer: `<p>La durée d’une refonte de site internet dépend de la complexité du projet et de vos besoins. Chez ALEO, un projet de refonte classique (refaire le design et le SEO) peut prendre quelques semaines. Cette période prend en compte l’audit initial, la planification stratégique, le design et le webdesign, le développement technique, et la mise en place des contenus.</p>
            <p class="mt-4">Nos équipes accordent un soin particulier à l’expérience utilisateur et au référencement naturel de votre site, ce qui peut influencer la durée de la refonte.</p>
            `,
        isCollapsed: false,
      },
      {
        question: "Quel est le prix d’une refonte chez ALEO ?",
        answer: `<p>Chez ALEO, le prix d’une refonte de votre site internet est à partir de <strong>49€/mois seulement.</strong></p>
            <p class="mt-4">Que votre objectif soit d'améliorer l'expérience utilisateur, de renforcer votre présence sur les moteurs de recherche, ou de mettre en place une stratégie de contenu et de marketing efficace, nous proposons dans notre catalogue différentes solutions pour vous permettre d’atteindre sereinement vos objectifs.</p>
            `,
        isCollapsed: false,
      },
      {
        question: "Comment se passe la refonte de votre site web avec ALEO ?",
        answer: `<p>La refonte de votre site web avec ALEO est un processus structuré, conçu pour maximiser l'efficacité et l'impact de votre présence en ligne.</p>
            <p class="mt-4">Notre approche commence par une compréhension approfondie de vos besoins et objectifs. Nous réalisons un audit par téléphone de votre site actuel, identifiant les opportunités d'amélioration en termes de design, d'expérience utilisateur, de SEO, et de performance technique.</p>
            <p class="mt-4">Ensuite, nous travaillons étroitement avec vous pour définir les objectifs de la refonte. Cela inclut l'amélioration de la navigation, l'optimisation pour les moteurs de recherche, en particulier Google, et l'adaptation du site aux besoins des utilisateurs mobiles.</p>
            <p class="mt-4">Nous accordons une attention particulière à la rédaction de contenus pertinents et pensés pour optimiser votre référencement naturel.</p>
            <p class="mt-4">Enfin, la phase de redirection assure une transition en douceur vers le nouveau site, préservant ainsi votre référencement et votre trafic existants.</p>
            `,
        isCollapsed: false,
      },
    ],
  }),

  head() {
    return {
      title: "ALEO, refonte de votre site internet en 5 étapes, guide et prix",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "ALEO, votre agence de refonte de site web, vous guide à travers 5 étapes essentielles. Profitez d'un accompagnement sur mesure et découvrez nos tarifs.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "ALEO, refonte de votre site internet en 5 étapes, guide et prix",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "ALEO, votre agence de refonte de site web, vous guide à travers 5 étapes essentielles. Profitez d'un accompagnement sur mesure et découvrez nos tarifs.",
        },
      ],
    };
  },
};
